import React, { Fragment } from 'react';

import * as Actions from 'catalogs/components/list/actions';

const CatalogsActions = ({ permissions, catalog, company, subcompany, handleToggle }) => {
  // console.log(permissions)
  return (
    <Fragment>
      {permissions['acl.catalogs.toggle'] && (
        <Actions.Toggle catalog={catalog} handleClick={handleToggle} />
      )}
      {permissions['acl.catalogs.update'] && (
        <Actions.Edit catalog={catalog} company={company} subcompany={subcompany} />
      )}
    </Fragment>
  );
};

export default CatalogsActions;



// WEBPACK FOOTER //
// src/modules/secured/modules/catalogs/components/list/CatalogsActions.js